import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ipManagementServices from '../../../services/ipManagement/ipServices';

export const fetchIPAddressesData = createAsyncThunk(
    "ipManagement/fetch",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await ipManagementServices.fetchIPAddresses(payload);
            if (!res.success) return rejectWithValue(res.message);
            return res.data; // {records, total, page, limit, totalPages}
        } catch (err) {
            return rejectWithValue(err.message || "Failed to fetch IP data");
        }
    }
);


export const createIPAddressData = createAsyncThunk(
    "ipManagement/create",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await ipManagementServices.createIPAddress(payload);
            if (!res.success) return rejectWithValue(res.message);
            return res;
        } catch (err) {
            return rejectWithValue(err.message || "Failed to create IP entry");
        }
    }
);


export const updateIPAddressData = createAsyncThunk(
    "ipManagement/update",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await ipManagementServices.updateIPAddress(payload);
            if (!res.success) return rejectWithValue(res.message);
            return res;
        } catch (err) {
            return rejectWithValue(err.message || "Failed to update IP entry");
        }
    }
);


const initialState = {
    list: [],
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0,
    },
    loading: false,
    error: null,
};


const ipManagementSlice = createSlice({
    name: "ipManagement",
    initialState,
    reducers: {
        clearIpError(state) {
            state.error = null;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(fetchIPAddressesData.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchIPAddressesData.fulfilled, (state, action) => {
            state.loading = false;
            state.list = action.payload.records || [];
            state.pagination = {
                total: action.payload.total,
                page: action.payload.page,
                limit: action.payload.limit,
                totalPages: action.payload.totalPages,
            };
        });
        builder.addCase(fetchIPAddressesData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to fetch IP address list";
            state.list = [];
        });


        builder.addCase(createIPAddressData.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(createIPAddressData.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(createIPAddressData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to create IP entry";
        });


        builder.addCase(updateIPAddressData.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateIPAddressData.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(updateIPAddressData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to update IP entry";
        });

    },
});

export const { clearIpError } = ipManagementSlice.actions;
export const ipManagementReducer = ipManagementSlice.reducer;
